import React, { useState } from "react";
import "../assets/index.less";
import "rc-slider/assets/index.css";
import { useForm } from "react-hook-form";
import Divider from "@mui/material/Divider";
import { StyledNewInstanceCard } from "../styles/StyledInstance";
import Slider from "@mui/material/Slider";
import CloseRounded from "@mui/icons-material/CloseRounded";
function InstanceCard({ setter, value, indicator, isLocked, isNewInstance }) {
  const { register, handleSubmit } = useForm();
  const [statusSet, setStatusSet] = useState(false);
  const onChange = (data) => {
    setStatusSet(true);
    setter({ score: data.target.value, comments: [...value.comments] });
  };
  const deleteComm = (i) => {
    const filteredComments = value.comments.filter((v, index) => i !== index);
    setter({ score: value.score, comments: filteredComments });
  };
  const onSubmit = (comment) => {
    setter({
      score: value.score,
      comments: [...value.comments, comment.Comment],
    });
  };
  return (
    <StyledNewInstanceCard>
      <h2>{indicator}</h2>
      {isLocked ? <p>Status</p> : <p>Select Status</p>}
      {!statusSet && <p className="status">No Status Set</p>}
      {!isLocked && statusSet && (
        <button
          onClick={() => {
            setStatusSet(false);
            setter({
              score: null,
              comments: [...value.comments],
            });
          }}
          className="reset"
        >
          Reset status
        </button>
      )}
      <Slider
        key={indicator}
        onChange={onChange}
        step={1}
        marks
        min={1}
        max={5}
        disabled={isLocked}
        value={value.score}
        valueLabelDisplay="on"
        className="slider"
      />
      {value.score !== null && value.score < 4 && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <label>Comments</label>
          <input
            className="comment-box"
            {...register("Comment")}
            placeholder="Start typing..."
            disabled={isLocked}
          />
          <input className="submit-btn" type="submit" value="+ Add Comment" />
        </form>
      )}
      <ul>
        {value.comments &&
          value.comments.map((comm, i) => {
            return (
              <li key={i}>
                <button
                  onClick={() => {
                    deleteComm(i);
                  }}
                >
                  <CloseRounded color="primary" sx={{ fontSize: 18 }} />
                </button>
                {comm}
              </li>
            );
          })}
      </ul>
      <Divider variant="middle" className="divider" />
    </StyledNewInstanceCard>
  );
}

export default InstanceCard;
